import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { ComponentProps } from 'react'

import NewsCard from '../components/NewsCard'
import { Section as TextSection } from './TextSection'

export const Section = styled.section(
  ({ theme }) => css`
    background: ${theme.colors.neutral1};
    padding: ${theme.spacing.x5}px 0;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      padding: ${theme.spacing.x5}px ${theme.spacing.x2}px;
    }

    ${TextSection} + & {
      margin-top: -${theme.spacing.x2}px;

      @media screen and (min-width: ${theme.breakpoints.tablet}px) {
        margin-top: -${theme.spacing.x8}px;
      }
    }
  `,
)
const Container = styled.div(
  ({ theme }) => css`
    margin: 0 auto;
    max-width: ${theme.spacing.gridMaxWidth}px;
    padding: 0 ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      padding: 0;
    }
  `,
)
const Title = styled.h2(
  ({ theme }) => css`
    ${theme.text.heading2(theme)}
    margin-bottom: ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      margin-bottom: ${theme.spacing.x5}px;
    }
  `,
)
const ArticlesContainer = styled.div(({ theme }) => [
  css`
    display: grid;
    gap: ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      gap: ${theme.spacing.x3}px;
      grid-template-columns: repeat(3, 1fr);
    }
  `,
  // All carousel code in one block
  css`
    @media screen and (max-width: ${theme.breakpoints.mobileMax}px) {
      grid-template-columns: 300px;
      grid-auto-flow: column;
      scroll-snap-type: x mandatory;
      scroll-behavior: smooth;
      overflow-x: auto;
      margin: 0 -${theme.spacing.x2}px;
      scroll-padding-left: ${theme.spacing.x2}px;
      padding: 0 ${theme.spacing.x2}px;

      > * {
        width: 300px;
        scroll-snap-align: start;
      }
    }
  `,
])

interface Props extends Omit<ComponentProps<typeof Section>, 'title'> {
  title?: string
  articles: Array<ComponentProps<typeof NewsCard>>
}

const RelatedArticlesSection = ({ title, articles, ...others }: Props) =>
  articles.length > 0 ? (
    <Section {...others}>
      <Container>
        {title && <Title>{title}</Title>}
        <ArticlesContainer>
          {articles.map((article) => (
            <NewsCard key={article.href} {...article} image={undefined} />
          ))}
        </ArticlesContainer>
      </Container>
    </Section>
  ) : null

export default RelatedArticlesSection
